import { Box } from '@10d/tend-ui-grid';
import { Dialog } from '@10d/tend-ui/primitives/Dialog';
import { Title } from '@10d/tend-ui/typography/Title';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { changelogApi } from 'api';
import { IChangelog } from '../../api/api/changelog/types';

export const showChangelogDialog = (changelog: IChangelog[]) => {
  const onOk = async () => {
    await changelogApi.read(changelog);
  };

  return Dialog.info({
    okText: 'Понятно',
    cancelButtonProps: { hidden: true },
    title: 'Система обновлена',
    content: <ChangelogContent changelog={changelog} />,
    width: 600,
    onOk,
  });
};

const ChangelogContent = ({ changelog }: { changelog: IChangelog[] }) => {
  return (
    <Box $flexDirection={'column'} $alignItems={'center'} $width={'100%'}>
      <Title level='h6'>Что изменилось:</Title>
      {changelog?.map(cl => (
        <Box
          key={cl.id}
          $flexDirection={'column'}
          $alignItems={'flex-start'}
          $width={'100%'}
        >
          <Title level='h4'>{cl.title}</Title>
          <ReactMarkdown>{cl.text}</ReactMarkdown>
        </Box>
      ))}
    </Box>
  );
};
